import React from 'react';

import PageContent from './content-type';
import PageAnalytics from './page-analytics';

/**
 * __Package page__
 */
const PackagePage = (props: any) => {
	const pageTitle = props.data.workspaceInfo.title;
	const tabNames: string[] = props.data.mdx.nodes
		.map((node: any) => node.parent.name)
		// "code" is a magical tab which only applies for top level pages.
		.concat('code');

	return (
		<PageAnalytics tabNames={tabNames} packageName={props.pageContext.name} pageTitle={pageTitle}>
			<PageContent {...props} />
		</PageAnalytics>
	);
};

export default PackagePage;
